import { useDispatch, useSelector } from "react-redux";
import Books from "../components/books/Books";
import { filterReducer } from "../redux/features/filter/filterSlice";

export default function Home() {
  const dispatch = useDispatch();
  const { filter } = useSelector((state) => state.filter);

  return (
    <main className="py-12 px-6 2xl:px-6 container">
      <div className="order-2 xl:-order-1">
        <div className="flex items-center justify-between mb-12">
          <h4 className="mt-2 text-xl font-bold">Book List</h4>

          <div className="flex items-center space-x-4">
            <button
              className={`lws-filter-btn ${
                filter === "showAll" && " active-filter"
              }`}
              onClick={() => dispatch(filterReducer("showAll"))}
            >
              All
            </button>
            <button
              className={`lws-filter-btn ${
                filter === "featured" && " active-filter"
              }`}
              onClick={() => dispatch(filterReducer("featured"))}
            >
              Featured
            </button>
          </div>
        </div>
        <Books />
      </div>
    </main>
  );
}
